import React from 'react';
import { FeedInstance, isFeedInstance } from '../../models/feed';
import { PromotionInstance } from '../../models/apis/promotion';
import s from './SubjectPlaceHolder.scss';
import { LinkWrapper } from '../BaseComp';

export interface SubjectPlaceHolderConfig {
    title: string,
    slogan: string,
    bgImage: string,
    source: Array<FeedInstance | PromotionInstance>,
    page: string
}

export const SubjectPlaceHolder = (props: SubjectPlaceHolderConfig) => {
    const { title, slogan, bgImage, source, page} = props;
    const feeds: FeedInstance[] = [];
    source.forEach(data => {
        if (isFeedInstance(data) && feeds.length < 3) {
            feeds.push(data);
        }
    });
    return (
        <div className={s.container}>
            {
                page?
                <a href={page} target="_blank">
                    <div className={s.titleBox}>
                        <img src={bgImage} alt={title} />
                        <h3>{title}</h3>
                        <p>{slogan}</p>
                    </div>
                </a>:
                <div className={s.titleBox}>
                    <img src={bgImage} alt={title} />
                    <h3>{title}</h3>
                    <p>{slogan}</p>
                </div>
            }
            {
                feeds.map((item, index) => <LinkWrapper className={s.feedTitle} href={item.url} key={item.id + index}><p>{item.title}</p></LinkWrapper>)
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/SubjectPlaceHolder/index.tsx